import React, { memo } from 'react'

import type { ProgressBarProps } from './types'
import classNames from 'classnames'

const ProgressBar = ({
  current,
  total,
  className = '',
  fullWidth,
}: ProgressBarProps) => {
  let progress = current / total

  if (current >= total) {
    progress = 1
  } else if (current <= 0 || total <= 0) {
    progress = 0
  }

  return (
    <div
      className={classNames('progress-bar-outer', {
        [className]: !!className,
        'progress-bar-outer--space': !fullWidth,
      })}
    >
      <div
        className="progress-bar-fill"
        style={{
          transform: `scaleX(${progress})`,
        }}
      />
    </div>
  )
}

export default memo(ProgressBar)
